import React from 'react';
import styles from './styles/titleInGame.module.css';

function TitleInGame() {
  return (
    <>
      <h3 className={styles.titleInGame}>Virus clicker</h3>
    </>
  );
}

export default TitleInGame;
